import { getMaskText } from 'utils/util';

export function getBankAccountType(bankInfo: {
    subtype?: string; // 银行卡类型
    institution_id: string; // 银行id, 可通过银行id判断是哪家银行
    mask?: string; // 银行账号后两位或四位
    account: string; // 银行账号（已脱敏）
}) {
    if (!bankInfo) {
        return '';
    }
    /**
     * institution_id === ins_56属于chase银行
     * 这个银行会单独返回一个mask字段用于展示银行账号
     */

    const maskInfo =
        bankInfo.institution_id === 'ins_56' ? getMaskText(bankInfo.mask) || bankInfo.account : bankInfo.account;

    if (!bankInfo?.subtype) {
        return maskInfo;
    }

    return `${bankInfo?.subtype?.toUpperCase()} ${maskInfo}`;
}
